import { CatalogSectionItemClassification } from '../../../../modules/catalogs/products/interfaces/catalogProductList.types';
import { ESColorClassification, ESProductTag } from '../../../../modules/products/ProductTypes';
import { percentToHex } from '../../../../utils/formatters';
import { DynamicTagAdapter } from '../DynamicTags.types';
import { DynamicTags } from '../DynamicTagsAdapter';

const isColorClassification = (tag: DynamicTags): tag is ESColorClassification => {
  return 'classificationType' in tag;
};

const isProductTag = (tag: DynamicTags): tag is ESProductTag => {
  return 'fontColor' in tag && 'backgroundColor' in tag && 'opacity' in tag;
};

export class ColorClassificationAdapter implements DynamicTagAdapter {
  constructor(private classification: ESColorClassification) {}

  toTag() {
    if (!this.classification.classificationType.useAsTag) {
      return null;
    }
    return {
      ...this.classification,
      label: this.classification.name,
    };
  }
}

export class ProductTagAdapter implements DynamicTagAdapter {
  constructor(private productTag: ESProductTag) {}

  toTag() {
    return {
      ...this.productTag,
      label: this.productTag.name,
      style: {
        backgroundColor: `${this.productTag.backgroundColor}${percentToHex(this.productTag.opacity)}`,
        color: this.productTag.fontColor,
      },
    };
  }
}

export class CatalogSectionItemAdapter implements DynamicTagAdapter {
  constructor(private catalogSectionItem: CatalogSectionItemClassification) {}

  toTag() {
    return {
      ...this.catalogSectionItem,
      label: this.catalogSectionItem.name,
    };
  }
}

export class DynamicDifferentsTagsAdapter implements DynamicTagAdapter {
  constructor(private tag: DynamicTags) {}

  toTag() {
    if (isColorClassification(this.tag)) {
      return new ColorClassificationAdapter(this.tag).toTag();
    }
    if (isProductTag(this.tag)) {
      return new ProductTagAdapter(this.tag).toTag();
    }
    return new CatalogSectionItemAdapter(this.tag).toTag();
  }
}
